import { useState, useCallback } from 'react';
import { savePrefParams } from './types';
import { selectUserEmail } from '@store/userData/selectors';
import { useSelector } from 'react-redux';
import { savePrefHandlerCallback, setGridPerferencesHandlerCallback } from './utils';

export const useGridPreferences = (gridKey: string) => {
	const [canBeSaved, setCanBeSaved] = useState(false);
	const userEmail = useSelector(selectUserEmail);
	const localStorageKey = `${userEmail}-${gridKey}`;

	// Handler to check and apply Grid states on initial load

	const setGridPerferencesHandler = useCallback(
		params => setGridPerferencesHandlerCallback(params, localStorageKey, setCanBeSaved),
		[localStorageKey],
	);

	// Handler to save Grid states

	const savePrefHandler = useCallback(
		(params: savePrefParams) => savePrefHandlerCallback(params, canBeSaved, localStorageKey),
		[canBeSaved, localStorageKey],
	);

	return {
		setGridPerferencesHandler,
		savePrefHandler,
	};
};
